let filterObject, selectors, dataValues;

var safeCurrency = typeof mostRecentCurrencySelected !== 'undefined'
  ? mostRecentCurrencySelected
  : 'CAD';

function getFirstByName(name) {
  return document.getElementsByName(name)[0] || null;
}

function safeSetValue(name, value) {
  var input = getFirstByName(name);
  if (input) input.value = value;
}

function safeSetHTML(id, value) {
  var el = document.getElementById(id);
  if (el) el.innerHTML = value;
}



if (window.location.href.indexOf('collections') != -1 && window.location.href.indexOf('products') == -1) {
    
    //jason2: hide raymond filters by when page loads until all data is displayed (dec 8 2020)
    document.getElementById("sidebarHandle").style.display = "none";
    document.getElementById("toggleFilterButton").style.display = "none";
 
    filterObject = {
      displayedProductsCount: 0,
      allProducts: [],
      filteredProducts: [],
      filtersAreActivated: false,
      allProductsCount: 0,
      paginationLimit: 0,
      filterOptions: {},
      filterCategory: [],
      filterOptionsSelected: [],
      filterCategoryOrder: [],
      allProductSaved: false,
      productsPerRow: 0,
    }

    selectors = {
      productWrapper: '[data-collection-product-wrapper]',
      allProductsCount: '[data-product-count]',
      productHandle: '[data-product-handle]',
      productTags: '[data-product-tags]',
      productPrice: '[data-product-price]',
      sidebarTemplate: '[sidebarFilter]',
      paginationLimit: '[data-pagination-limit]',
      collectionListWrapper: '[collection-list-wrapper]',
      loadMore: '[load-more-button]',
      priceSlider: '[price-slider]',
      weightSlider: '[weight-slider]',
      heightSlider: '[height-slider]',
      cupSlider: '[breast_cup-slider]',
      filterCategory: '[data-filter-category]'
      
    };

    dataValues = {
      productsPerRow: "data-products-per-row",
      productPrice: 'product-price-ammount',
      filterOptionCategory: 'filter-category'
    }

    function checkFiltersActivated(){
      if (filterObject.priceFilterSelected == undefined && filterObject.weightFilterSelected == undefined && 
        filterObject.cupSizeFilterSelected == undefined && filterObject.filterOptionsSelected.length == 0 &&
        filterObject.heightFilterSelected == undefined ) {
          // console.log(filterObject.priceFilterSelected, filterObject.weightFilterSelected, filterObject.cupSizeFilterSelected, filterObject.filterOptionsSelected.length)
          filterObject.filtersActivated = false;
          return false;
        } else{
          filterObject.filtersActivated = true;
          return true;
        }
    }

    function addLoadMoreButton(){
      $(selectors.collectionListWrapper).append(filterObject.loadMore);
        $(selectors.loadMore).find('a').click(function(){
         // add wishlist icon after load more button
            if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
           // add to compare load on products call
             if(typeof initSACMPJQuery == 'function'){
                initSACMPJQuery();
             }
          showProducts();
          // add wishlist icon after load more button
            if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
           // add to compare load on products call
             if(typeof initSACMPJQuery == 'function'){
                initSACMPJQuery();
             }
      });

    }

    function removeAllProducts(){
      $(selectors.productWrapper).remove();
      $(selectors.collectionListWrapper).find('.product_clear').remove();
      filterObject.displayedProductsCount = 0;
      // console.log('Products Removed')
    }

    function removeLoadMore(){
      $(selectors.loadMore).remove();
      // console.log('Load More button Removed')
    }

    function updateTagFilters(){
      let tempArray = [];
      let counts = {}
      var filter = filterObject.lastFilterSelected;
      // filter is undefined, process filtered products
      if (checkFiltersActivated()) {
        $.each(filterObject.filteredProducts,function(index, value){
          if (value.tags.length > 0) {
            tempArray = $.merge(tempArray,value.tags)  
          }
        });
      } else {
        $.each(filterObject.allProducts,function(index, value){
          if (value.tags.length > 0) {
            tempArray = $.merge(tempArray,value.tags)  
          }
        })
      }


      // Return unique filter object [counts]
      tempArray.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });
      filterObject.filterOptions = counts;
    }

    function breastConvert(value){
      var sizeToNumber = {"A": 1, "B": 2, "C": 3, "D": 4, "E": 5, "F": 6, "G": 7, "H": 8, "I": 9, "J": 10,"K": 11,"L": 12,"M": 13,"N": 14,"O": 15,"P": 16,"Q": 17,"R": 18,"S": 19,"T": 20};
      var numberToSize = {1: "A", 2: "B", 3: "C", 4: "D", 5: "E", 6: "F", 7: "G", 8: "H", 9: "I", 10:"J", 11: "K", 12: "L", 13: "M", 14: "N", 15: "O", 16: "P", 17: "Q", 18: "R", 19: "S", 20: "T"};

      if (typeof value === 'string') {
        return sizeToNumber[value];
      } else  {
        return numberToSize[value];
      }
      
    }


    function heightConvert(value){
      

      if (typeof value === 'string') {

        feet = parseInt(value.split(" ")[0]);
        


      } else  {
        var inches = (value*0.393700787).toFixed(0);
        var feet = Math.floor(inches / 12);
        inches %= 12;
        return feet + "ft" + inches + ' in'
      }


      
    }

    function updatePrices(){
      var prices = [];
      var filter = filterObject.lastFilterSelected;
      // filter is undefined, process filtered products

      if (checkFiltersActivated()) {
        $.each(filterObject.filteredProducts,function(index,value){
          prices.push(value.price);
        })
      } else {
        $.each(filterObject.allProducts,function(index,value){
          prices.push(value.price);
        })
      }

      // set max / min price for filter Object
      filterObject.maxPrice = parseFloat(Math.max.apply(Math, prices))
      filterObject.minPrice = parseFloat(Math.min.apply(Math, prices))

      // console.log("Prices Changed:   " ,prices,filterObject.maxPrice, filterObject.minPrice);
    }

    function updateWeights(){
      
      var weights = [];
      var filter = filterObject.lastFilterSelected;
      // filter is undefined, process filtered products
      
      if (checkFiltersActivated()) {
        $.each(filterObject.filteredProducts,function(index,value){
          weights.push(value.weight);
        })
      } else {
        $.each(filterObject.allProducts,function(index,value){
          weights.push(value.weight);
        })
      }

      if (checkFiltersActivated() && filterObject.filteredProducts.length <= 0 ) {
        // Set min / max for weights
        filterObject.maxWeight = 0
        filterObject.minWeight = 0
          
      } else {

        // Set min / max for weights
        filterObject.maxWeight = Math.max.apply(Math, weights)
        filterObject.minWeight = Math.min.apply(Math, weights)

      }
      
      

      // console.log("Weigths updated :   " ,weights,filterObject.maxPrice, filterObject.minWeight);
    }

    function updateBreastCup(){
      var breastCups = [];
      var filter = filterObject.lastFilterSelected;
      // filter is undefined, process filtered products

      if (checkFiltersActivated()) {
        $.each(filterObject.filteredProducts,function(index,value){
          convertedValue = breastConvert(value.breastCup)
          breastCups.push(convertedValue);
        })
      } else {
        $.each(filterObject.allProducts,function(index,value){
          convertedValue = breastConvert(value.breastCup)
          breastCups.push(convertedValue);
        })
      }
    
      // Set min / max for breast
      if (checkFiltersActivated() && filterObject.filteredProducts.length <= 0 ) {
        filterObject.maxCup = "A"
        filterObject.minCup ="A"
      } else {
        filterObject.maxCup = breastConvert(Math.max.apply(Math, breastCups));
        filterObject.minCup = breastConvert(Math.min.apply(Math, breastCups));
      }
      
      // console.log("Breasts updated :   " ,breastCups,filterObject.maxCup, filterObject.minCup);
    }

    function updateHeights(){
      
      var heights = [];
      var filter = filterObject.lastFilterSelected;
      // filter is undefined, process filtered product
      
      if (checkFiltersActivated()) {
        $.each(filterObject.filteredProducts,function(index,value){
          heights.push(value.height);
          // console.log("LOOPING THROUGHT FILTERED PRODUCTS")
        })
        
      } else {
        $.each(filterObject.allProducts,function(index,value){
          heights.push(value.height);
        })
      }
    
      // Set min / max for heights
      if (checkFiltersActivated() && filterObject.filteredProducts.length <= 0 ) {
        filterObject.minHeight = 0
        filterObject.maxHeight = 0

      } else {
        filterObject.maxHeight = Math.max.apply(Math, heights)
        filterObject.minHeight = Math.min.apply(Math, heights)
      }
      

      console.log("HEIGHTS updated :   " ,heights,filterObject.minHeight, filterObject.maxHeight);
    }

    function checkSlidersIfEmpty(){
      // set default values for sliders 
      if (filterObject.defaultPrice != undefined) {
        if (filterObject.defaultPrice[0] == 0 && filterObject.defaultPrice[1] == 0 ) {
          $(selectors.priceSlider).parent().parent().parent().remove();
        }
      }

      if (filterObject.defaultWeight != undefined) {
        if (filterObject.defaultWeight[0] == 0 && filterObject.defaultWeight[1] == 0 ) {
          $(selectors.weightSlider).parent().parent().parent().remove();
        }
      }

      if (filterObject.defaultCup != undefined) {
        if (filterObject.defaultCup[0] == "A" && filterObject.defaultCup[1] == "A" ) {
          $(selectors.cupSlider).parent().parent().parent().remove();
        }
      }

      if (filterObject.defaultHeight != undefined) {
        
        if (filterObject.heightSlider[0] == 0 && filterObject.defaultHeight[1] == 0 ) {
          alert(filterObject.defaultHeight[0] + filterObject.defaultHeight[1])
          $(selectors.heightSlider).parent().parent().parent().remove();
        }
      }
    }

    function updateAllFilters(){
      // FilterSelected = Filter to except 
      // this includes populateFilters
      // console.log('updating filter settings')
      filterSelected = filterObject.lastFilterSelected;
      updateTagFilters();
      updatePrices();
      updateWeights();
      updateBreastCup();
      updateHeights();
      
      if (checkFiltersActivated()) {
        // Update Price Slider and filter settings
        // if filter selected i not price, update price settings
        if (filterSelected != 'price') {
          if (filterObject.priceFilterSelected == undefined && window.noUiSlider != undefined) {
            filterObject.priceSlider.noUiSlider.updateOptions({
              start: [filterObject.minPrice, filterObject.maxPrice],
              step: 1
            });
          } 
        } 

        // Update Weight Slider and filter settings
        // if filter selected i not weight, update weight settings
        if (filterSelected != 'weight' && filterObject.weightFilterSelected == undefined) {
          filterObject.weightSlider.noUiSlider.updateOptions({
              start: [filterObject.minWeight, filterObject.maxWeight],
              step: 1
          });
        }

        // Update Breast Cup Slider and filter settings
        if (filterSelected != 'breast-cup' && filterObject.cupSizeFilterSelected == undefined) {
          
          // console.log('Updating Breast Cup')
          filterObject.cupSize.noUiSlider.updateOptions({
              start: [breastConvert(filterObject.minCup), breastConvert(filterObject.maxCup)],
              step: 1
          });
        }

        // Update HeightSlider and filter settings
        if (filterSelected != 'height' && filterObject.heightFilterSelected == undefined) {
          
          filterObject.heightSlider.noUiSlider.updateOptions({
              start: [filterObject.minHeight, filterObject.maxHeight],
              step: 1
          });
        }

        // Show Checkbox filters

      } else {
        // No Filter is selected 
       
        // Update Price Slider and filter settings
        if (window.noUiSlider == undefined) {
          document.querySelector('#sidebarLoadingHandle').style.opacity = '0'
          return
        }
        filterObject.priceSlider.noUiSlider.updateOptions({
            range: {
                'min': filterObject.minPrice,
                'max': filterObject.maxPrice
            },
            start: [filterObject.minPrice, filterObject.maxPrice],
            step: 1
        });

        // Update Weight Slider
        filterObject.weightSlider.noUiSlider.updateOptions({
            range: {
                'min': filterObject.minWeight,
                'max': filterObject.maxWeight
            },
            start: [filterObject.minWeight, filterObject.maxWeight],
            step: 1
        });

        // Update Height Slider
        filterObject.heightSlider.noUiSlider.updateOptions({
            range: {
                'min': filterObject.minHeight,
                'max': filterObject.maxHeight
            },
            start: [filterObject.minHeight, filterObject.maxHeight],
            step: 1
        });

        // Update Breast Cup Slider
        var minCup = breastConvert(filterObject.minCup);
        var maxCup = breastConvert(filterObject.maxCup)
        // console.log(filterObject)
        // console.log(minCup, maxCup)
        filterObject.cupSize.noUiSlider.updateOptions({
            range: {
                'min': minCup,
                'max': maxCup
            },
            start: [minCup, maxCup ],
            step: 1
        });
        

      }

      populateFilters();

      // check if sliders are empty
      // checkSlidersIfEmpty();

      // console.log(filterObject)
    }

    function showProducts() {
      // loop through products 
      filterSelected = filterObject.lastFilterSelected;
      if (checkFiltersActivated() ) {
        var startAt = filterObject.displayedProductsCount;
        var collectionList = $('.product-list');
        var count = filterObject.paginationLimit + startAt;
        var appendRow = false;
        var listOfElements = [];

        for (let i = startAt; i < count; i++) {
          
          // Break loop if max products Reached
          if (i >= filterObject.filteredProducts.length) {
            removeLoadMore();
            break
          }
    
          // Create Product Item
          var element = $(filterObject.filteredProducts[i].element);
          element.removeClass();
          // create Wrapper Class
          var productWrapperClass ="";
          switch (filterObject.productsPerRow) {
            case 2:
              if (i % 2 == 0) {
                productWrapperClass = "six columns alpha"
    
              } else {
                productWrapperClass = "six columns omega"
                appendRow = true;
              }
              break;
            case 3:
              var classLoop = ['alpha','','omega'];
              var appendLoop = [false,false,true];
              productWrapperClass = "four columns " + classLoop[i % 3]
              appendRow = appendLoop[i % 3]
              break;
            case 4:
              var classLoop = ['alpha','','','omega'];
              productWrapperClass = "three columns " + classLoop[i % 3]
              var appendLoop = [false,false,false,true];
              appendRow = appendLoop[i % 3]
              break;
            default:
              var classLoop = ['alpha','','','','omega'];
              var appendLoop = [false,false,false,false,true];
              productWrapperClass = "one-fifth-sidebar column " + classLoop[i % 7]
              appendRow = appendLoop[i % 3]
              break;
          }
    
          // create Second Wrapper Class
    
          if (i % 2 == 0) {
            productWrapperClass = productWrapperClass + " thumbnail even"
          } else {
            productWrapperClass = productWrapperClass + " thumbnail odd"
          }
          
          // Add new Class
          element.addClass(productWrapperClass);
          
          
          // Append Product to collection list
          collectionList.append(element);
          if (appendRow == true) {
            collectionList.append('<br class="clear product_clear">');
          }
    
          // incremenent displayed products 
          filterObject.displayedProductsCount += 1;

        }

        // END OF LOOP for filtered Products

        // Show Load More if there are more avaialble product
        if (filterObject.displayedProductsCount < filterObject.filteredProducts.length ) {
          filterObject.loadMore.removeClass('isHidden');
          addLoadMoreButton();
        } else {
          removeLoadMore();
        }
        
      } else {

        var startAt = filterObject.displayedProductsCount;
        var collectionList = $('.product-list');
        var count = filterObject.paginationLimit + startAt;
        var appendRow = false;

        for (let i = startAt; i < count; i++) {
          // Break loop if max products Reached
          if (i >= filterObject.allProductsCount) {
            removeLoadMore();
            break
          }

          // Create Product Item
          var element = $(filterObject.allProducts[i].element);
          element.removeClass();

          // create Wrapper Class
          var productWrapperClass =""
          switch (filterObject.productsPerRow) {
            case 2:
              if (i % 2 == 0) {
                productWrapperClass = "six columns alpha"

              } else {
                productWrapperClass = "six columns omega"
                appendRow = true;
              }
              break;
            case 3:
              var classLoop = ['alpha','','omega'];
              var appendLoop = [false,false,true];
              productWrapperClass = "four columns " + classLoop[i % 3]
              appendRow = appendLoop[i % 3]
              break;
            case 4:
              var classLoop = ['alpha','','','omega'];
              productWrapperClass = "three columns " + classLoop[i % 3]
              var appendLoop = [false,false,false,true];
              appendRow = appendLoop[i % 3]
              break;
            default:
              var classLoop = ['alpha','','','','omega'];
              var appendLoop = [false,false,false,false,true];
              productWrapperClass = "one-fifth-sidebar column " + classLoop[i % 7]
              appendRow = appendLoop[i % 3]
              break;
          }

          // create Second Wrapper Class

          if (i % 2 == 0) {
            productWrapperClass = productWrapperClass + " thumbnail even"
          } else {
            productWrapperClass = productWrapperClass + " thumbnail odd"
          }
          
          
          // Add new Class
          element.addClass(productWrapperClass);

          
          // Append Product to collection list
          collectionList.append(element);

          if (appendRow == true) {
            collectionList.append($('<br class="clear product_clear">'));
          }

          // incremenent displayed products 
          filterObject.displayedProductsCount += 1;
        } 
        
        // END OF LOOP

        if (filterObject.displayedProductsCount < filterObject.allProductsCount) {
          filterObject.loadMore.removeClass('isHidden');
          addLoadMoreButton();
        } else {
          removeLoadMore()
        }
      }

      if (shopify_global.show_multiple_currencies == 'true') {
        convertCurrencies();
      }

      console.log(filterObject)
    }

    function reloadItemsWithFilters(){
      // This will generate filtered products
      removeLoadMore();
      removeAllProducts();
  
      filterObject.displayedProductsCount = 0;
      filterObject.filterOptions = {};
      filterObject.filteredProducts = [];
      
      // Populate filteredProducts
      // console.log("FILTERS")
      // console.log(`Filter Price : ${filterObject.priceFilterSelected}`)

      $.each(filterObject.allProducts,function(index ,value){
        // Temporary, set this in filterObject.
        var filterCount = 0;
        var defaultFilterCategory = $('[data-category]').length;
        valuePrice = value.price;
        // if price is Set 
        if (filterObject.priceFilterSelected != undefined) {
          if (valuePrice >= filterObject.priceFilterSelected[0] && valuePrice <= filterObject.priceFilterSelected[1]) {
            filterCount += 1;
          }
        } else {
          filterCount += 1;
        }

        // if weight is Set

        if (filterObject.weightFilterSelected != undefined) {
          if (value.weight >= filterObject.weightFilterSelected[0] && value.weight <= filterObject.weightFilterSelected[1]) {
              filterCount += 1;
          }
        } else {
          filterCount += 1;
        }

        // if cupsize is Set

        if (filterObject.cupSizeFilterSelected != undefined) {
          var breastCup = breastConvert(value.breastCup);
          var minSelected = breastConvert(filterObject.cupSizeFilterSelected[0]);
          var maxSelected = breastConvert(filterObject.cupSizeFilterSelected[1]);

          if (breastCup >= minSelected && breastCup <= maxSelected) {
              filterCount += 1;
          }

        } else {
          filterCount += 1;
        }

         // if price is Set

         if (filterObject.heightFilterSelected != undefined) {
          if (value.height >= filterObject.heightFilterSelected[0] && value.height <= filterObject.heightFilterSelected[1]) {
              filterCount += 1;
          }
        } else {
          filterCount += 1;
        }

        // dataFilterCategory : Number of filter range available
        // filterCount: To validate if all filter ranges have been processed

        if (filterCount == defaultFilterCategory ) {
          // Check if Tag filters are enabled
          if (filterObject.filterOptionsSelected.length == 0) {
            filterObject.filteredProducts.push(value);
          } else {
            // Loop through all selected options
            value.tags.forEach( function (filter) {
              if (filterObject.filterOptionsSelected.includes(filter)) {
                filterObject.filteredProducts.push(value);
              }
            });
          } 
        }
      }); 
      
      

        updateAllFilters();
      // update wishlist and add to compare button call to the app
        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
       // add to compare load on products call
             if(typeof initSACMPJQuery == 'function'){
                initSACMPJQuery();
             }
        showProducts()
        
        // update wishlist and add to compare button call to the app
        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
         // add to compare load on products call
             if(typeof initSACMPJQuery == 'function'){
                initSACMPJQuery();
             }
    }

    function sortProducts(currentSort) {
      var products = [];

      $.each(filterObject.allProducts, function(index,value) {
        products.push(value);
      });

      switch (currentSort) {
        case 'title-ascending':
          products = products.sort(function(a,b) {
                        if(a.title.toLowerCase() < b.title.toLowerCase()) {
                            return -1;
                        }
                        if(a.title.toLowerCase() > b.title.toLowerCase()){
                            return 1;
                        } else {
                            return 0;
                        }
                    });
          break;

        case 'best-selling':
          products = filterObject.bestsellingSort;
          break;

        case 'title-descending':
          products = products.sort(function(a,b) {
                      if(a.title.toLowerCase() < b.title.toLowerCase()) {
                          return 1;
                      }
                      if(a.title.toLowerCase() > b.title.toLowerCase()){
                          return -1;
                      } else {
                          return 0;
                      }
                  });
          break;

        case 'price-ascending':
            products = products.sort(function(a,b) {return (a.price - b.price)});
            break;
        case 'price-descending':
            products = products.sort(function(a,b) {return (b.price - a.price)});
            break;
        case 'created-ascending':
            products = products.sort(function(a,b) {return (new Date(a.published_at) - new Date(b.published_at))});
            break;
        case 'created-descending':
            products = products.sort(function(a,b) {return (new Date(b.published_at) - new Date(a.published_at))});
            break;
     
      }

      filterObject.allProducts = products;
      // console.log("SORT: " + currentSort, filterObject.allProducts)
      reloadItemsWithFilters()

    }

    function activateSort(){
      removeLoadMore();
      removeAllProducts();
      filterObject.displayedProductsCount = 0;

      var query = filterObject.sortBy.val();
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?sort_by=" + query;
      window.history.pushState({path:newurl},'',newurl);
     
      sortProducts(query)
    }

    function createUpdateCheckboxFilter(category,filter,count){
      // pass category, filter and count .split("_").join(" ");
      
      var parsedFilter = filter.split("_").join(" ");
      var filterSelector = filter.split("_").join("-");
      // check for special characters
      filterSelector = filterSelector.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
      

      var parentDiv = $('[data-filter-category="' + category + '"]');

      // Check if filter already exists in the tab
      var search = '[_' + filterSelector + ']' //updated by jason2 on dec 8, 2020 to allow brand names that start with a # (underscore prefix inserted) 
      if ($(search).length > 0) {
        //console.log("EXISTING", filter, count)
        $(search).next().html('( ' + count + ' )');
        
      } else {
        // Create a filter
        var wrapperClass = document.createElement('div')
        wrapperClass.setAttribute("class","sidebar__checkbox");

        var labelWrap = document.createElement('label');
        labelWrap.setAttribute('for',filterSelector)

        var input = document.createElement('input');
        input.setAttribute('type','checkbox');
        input.setAttribute('data-option-filter',filter);
        input.setAttribute('id',filterSelector)
        input.setAttribute("_" + filterSelector,'');
        
		//added by jason2 to preselect checkboxes if URL contains them (dec 8, 2020)
        if (url().includes('filter-' + category + '-' + filter)) {
          input.setAttribute('checked', 'true');
          var filterOption = 'filter-' + category + '-' + filter;
      	  filterObject.lastFilterSelected = category;
          filterObject.filterOptionsSelected.push(filterOption)
          filterObject.filtersActivated = true;
          filterObject.filterCategoryOrder.push(category)
        }

        var span = document.createElement('span');
        span.textContent="( " + count + " )";

        labelWrap.append(input);
        labelWrap.append(parsedFilter);
        //labelWrap.append(span);
        wrapperClass.append(labelWrap);

        
        $(labelWrap).onclick
        // Add event for check box

        $(input).change(
          function(){
              var filterOption = 'filter-' + category + '-' + $(this).data('option-filter');
              if (this.checked) {
                  filterObject.lastFilterSelected = category;
                  filterObject.filterOptionsSelected.push(filterOption)
                  filterObject.filtersActivated = true;
                  filterObject.filterCategoryOrder.push(category)
                  reloadItemsWithFilters()

              } else {
                  filterObject.filterOptionsSelected = filterObject.filterOptionsSelected.filter(e => e !== filterOption);
                  if (filterObject.filterOptionsSelected.length == 0 ) {
                    filterObject.lastFilterSelected = undefined;
                  }
                  reloadItemsWithFilters()
              }

              // console.log(filterObject)
          });

        parentDiv.append(wrapperClass)
      }
    }

    function populateFilters(){
      var options = filterObject.filterOptions;
      filterObject.filterCategory = [];

      // Get all categories avaialble for checkboxes
     
        // Loop for existing categories
        $.each($(selectors.filterCategory),function(index,value){
          var category  = $(value).data(dataValues.filterOptionCategory).split(" ").join("_");

          filterObject.filterCategory.push(category);

          // Show Filters 
          $.each(options, function(index,value){
            if (index.includes(category)) {

			  //jason2: duct tape to get around problem with tags containing dashes (dec 8 2020)
              index = index.replace("filter-" + category + "-", "");
              index = index.replace("-", "|"); //convert dashes in tag name to vertical bars before the parsing below, then swap dashes back before displaying on page
              index = "filter-" + category + "-" + index;
              //console.log("j2 mystery: " + index);
              var filter = index.split('-');
              var parsedFilter = filter[filter.length -1].replace("|","-"); //remove the duct tape
              //end
              
              createUpdateCheckboxFilter(category, parsedFilter, value)
            }
          });

        });
      

      // remove filters if not in options
      var allTagFilterCategory = $('[data-filter-category]');
      $.each(allTagFilterCategory,function(categoryIndex,categoryElement){

        var category = $(categoryElement).data('filter-category');
        var filters = $(categoryElement).find('[data-option-filter]');
        var isExisting = false;

        // check if category in not currently selected
        if ( category != filterObject.lastFilterSelected) {

          // loop for all displayed filters
          $.each(filters,function(filterIndex,filterElement){
            var filter = 'filter-' + category + '-' + $(filterElement).data('option-filter');
            // console.log(filter)

            // check if inside filter options, hide if not
            $.each(options, function(filterIndexValue,count){
              if (filterIndexValue == filter) {
                isExisting = true;
                return false;
              }
            });

            // if filter is not included, remove
            if (isExisting == false) {
              // remove parent
              $(filterElement).parent().parent().remove() 
            }
          });
        }

        // Hide or Show category if no filters avaialble
        if ($(categoryElement).find('[data-option-filter]').length > 0) {
          $(categoryElement).parent().parent().show()
        } else {
          $(categoryElement).parent().parent().hide()
        }
        
      });

    }

    function retrieveRemainingProducts(page, initialLoad, fromSort){
      // console.log ("GETTING REMAINING PRODUCTS")
      var query = "";

      var siteUrl = 'https://' + $.url('hostname'),
      url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
      url2 = $.url('2') ? $.url('2') + '/' : '',
      url3 = $.url('3'),
      path = url1 + url2;

      var query = filterObject.sortBy.val();

      var finalURL = path + "?sort_by=featured" + "&page=" + page;

      let getProducts =  $.ajax({
        type: 'GET',
        url: finalURL,
        dataType: "html",
        success: function(data) {
      }});
    
      getProducts.done(function(data){

        let products = $(data).find('[data-collection-product-wrapper]');
        // console.log("PRODUCTS FROM PAGE: " + page, products)
        // console.log("LINK: " + finalURL)
        // console.log(data);
        
        // Wishlist Reload on Products call 
          if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
         // add to compare load on products call
             if(typeof initSACMPJQuery == 'function'){
                initSACMPJQuery();
             }
             

        // loop through products and save data
        $.each($(products),function(index,value){
          // console.log(value)
          var tags = $(value).find(selectors.productTags).attr(selectors.productTags.slice(1,-1)).slice(0,-1).split(',');
          var handle = $(value).find(selectors.productHandle).attr(selectors.productHandle.slice(1,-1));
          // console.log($(value).find(selectors.productHandle));
          // console.log( $(value).find(selectors.productHandle).data(dataValues.productPrice));
          // console.log(String($(value).find(selectors.productHandle).data(dataValues.productPrice)));
          
          let price = parseFloat(String($(value).find(selectors.productHandle).data(dataValues.productPrice)).replace(',',''));
          let title = $(value).find(selectors.productHandle).data('product-title');
          let published_at = $(value).find(selectors.productHandle).data('product-published')
          let weight = 0;
          
          //bookmark(1)
          //console.log(title + ">>>" + tags);
          
          // Get weight value from tags
          $.each(tags,function(index,value){
            if (value.includes('Weight')) {
              var tempArray = value.split('-');
              weight = parseInt(tempArray[tempArray.length-1]);
            }
          })
          let breastCup = "A";
          // Get Breast Cup value from tags
          $.each(tags,function(index,value){
            if (value.includes('Breast_Cup')) {
              var tempArray = value.split('-');
              breastCup = tempArray[tempArray.length-1];
              // console.log(breastCup)
            }
          })
          let height = 0;
          // Get Height value from tags
          $.each(tags,function(index,value){
            if (value.includes('Height')) {
              var tempArray = value.split('-');
              height = parseInt(tempArray[tempArray.length-1]);
            }
          })

          // push object to array
          var prodObj = {
                        "element":value, 
                        "published_at": published_at, 
                        "title": title, 
                        "price": price, 
                        "tags": tags, 
                        "weight": weight, 
                        "height": height,
                        "breastCup": breastCup, 
                        "handle": handle 
                      }

          filterObject.allProducts.push(prodObj)
        });

        if(initialLoad){
          showProducts();
        }
        
        // Check if there are still remaining products
        if (filterObject.allProducts.length >= filterObject.allProductsCount) {
          
            //jason2: hide the filter loading div after raymond filter is loaded (dec 8 2020)
			console.log("j2: raymond filter loaded");
          	if(window.innerWidth < 798) document.getElementById("toggleFilterButton").style.display = "block";
            document.getElementById("sidebarHandle").style.display = "block";
          	document.getElementById("sidebarLoadingHandle").style.display = "none"; 
          
          filterObject.allProductSaved = true;
          updateAllFilters()

          // set default values for sliders 
          if (filterObject.defaultPrice == undefined) {
            filterObject.defaultPrice = [filterObject.minPrice, filterObject.maxPrice]
          }

          if (filterObject.defaultWeight == undefined) {
            filterObject.defaultWeight = [filterObject.minWeight, filterObject.maxWeight]
          }

          if (filterObject.defaultCup == undefined) {
            filterObject.defaultCup = [filterObject.minCup, filterObject.maxCup]
          }

          if (filterObject.defaultHeight == undefined) {
            filterObject.defaultHeight = [filterObject.minHeight, filterObject.maxHeight]
          }

         
          // save best-selling sort
          if (filterObject.bestsellingSort == undefined) {
            filterObject.bestsellingSort = filterObject.allProducts;
          }
         
          // check if filters areactivated
          if (checkFiltersActivated()) {
            reloadItemsWithFilters();
          } else {
            updateAllFilters()
          }
          
        } else {
          console.log("j2: loading products from page: " + page);
          retrieveRemainingProducts(page + 1,false)
        }

      });

    }

    function resetAll(){

      // Check if filter is activated 

      if (checkFiltersActivated()) {
        filterObject.filterOptionsSelected = [];
        filterObject.priceFilterSelected = undefined;
        filterObject.weightFilterSelected = undefined;
        filterObject.heightFilterSelected = undefined;
        filterObject.cupSizeFilterSelected = undefined;

        // Check if price slier is added
        if (filterObject.defaultPrice != undefined) {
          filterObject.minPrice = filterObject.defaultPrice[0];
          filterObject.maxPrice = filterObject.defaultPrice[1];
        }

        // Check if weight slier is added
        if (filterObject.defaultWeight != undefined) {
          filterObject.minWeight = filterObject.defaultWeight[0];
          filterObject.maxWeight = filterObject.defaultWeight[1];
        }

        // Check if height slier is added
        if (filterObject.defaultHeight != undefined) {
          filterObject.minHeight = filterObject.defaultHeight[0];
          filterObject.maxHeight = filterObject.defaultHeight[1];
        }

        // Check if breast slier is added
        if (filterObject.defaultCup != undefined) {
          filterObject.minCup = filterObject.defaultCup[0];
          filterObject.maxCup = filterObject.defaultCup[1];
        }


        
        updateAllFilters();
        reloadItemsWithFilters();
        
      } 

      
    }

    function initializeSettings(){    

      /*========= 
        SORT BY
      ========= */

      filterObject.sortBy = $('#collection-sort-by');
      filterObject.sortBy.val((filterObject.sortBy).data('default-sort'));
      var query = "";
      if (filterObject.sortBy.length){
        query = filterObject.sortBy.val();
      } else {
        query = url('?sort_by');
      }
      
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?sort_by=" + query;
      window.history.pushState({path:newurl},'',newurl);

      filterObject.sortBy.change(function(){
        activateSort();
      })

      filterObject.allProductsCount = parseInt($(selectors.allProductsCount).attr(selectors.allProductsCount.slice(1,-1)));
      filterObject.paginationLimit = parseInt($(selectors.paginationLimit).attr(selectors.paginationLimit.slice(1,-1)));
      filterObject.productsPerRow = parseInt($(selectors.collectionListWrapper).attr(dataValues.productsPerRow))


      /*========= 
        PRICE FILTER / SLIDER
        ========= */

      // CURENCY SWITCHER FIX

      filterObject.moneyFormat = wNumb({
          decimals: 2,
          thousand: ','
      });
      

      filterObject.priceSlider = document.querySelector(selectors.priceSlider);
      if (window.noUiSlider == undefined) return;
      noUiSlider.create(filterObject.priceSlider, {
          start: [0, 10],
          connect: true,
          range: {
              'min': 0,
              'max': 10
          },
          format: filterObject.moneyFormat
      });

      // Event listener for price slider
      filterObject.priceSlider.noUiSlider.on('change',function(value,handle){
        var filterName = 'price'
        filterObject.filtersActivated = true;
        filterObject.filterCategoryOrder.push(filterName)
        filterObject.lastFilterSelected = filterName;
        if (parseFloat(filterObject.moneyFormat.from(value[0])) == filterObject.defaultPrice[0] && parseFloat(filterObject.moneyFormat.from(value[1])) == filterObject.defaultPrice[1]) {
            filterObject.priceFilterSelected = undefined;
            // console.log("PRICE FORMAT BACK TO NORMAL, undefined")
        } else {
          filterObject.priceFilterSelected = [filterObject.moneyFormat.from(value[0]),filterObject.moneyFormat.from(value[1])];
        }
        reloadItemsWithFilters();
      });

     // Set visual min and max values and also update value hidden form inputs
        filterObject.priceSlider.noUiSlider.on('update', function(values, handle) {
          safeCurrency = typeof mostRecentCurrencySelected !== 'undefined'
            ? mostRecentCurrencySelected
            : 'CAD';

          var minPrice = filterObject.moneyFormat.from(values[0]);
          var maxPrice = filterObject.moneyFormat.from(values[1]);

          if (typeof Currency !== 'undefined' && Currency.convert) {
            minPrice = parseFloat(Currency.convert(minPrice, 'CAD', safeCurrency)).toFixed(2);
            maxPrice = parseFloat(Currency.convert(maxPrice, 'CAD', safeCurrency)).toFixed(2);
          }

          safeSetHTML('price-slider__slider-range-value1', minPrice);
          safeSetHTML('price-slider__slider-range-value2', maxPrice);

          safeSetValue('price-slider__min-value', values[0]);
          safeSetValue('price-slider__max-value', values[1]);
        });


         // currency switcher
        if (typeof currencySelector !== 'undefined' && currencySelector) {
  currencySelector.addEventListener('change', function() {
    safeCurrency = typeof mostRecentCurrencySelected !== 'undefined'
      ? mostRecentCurrencySelected
      : 'CAD';

    var minInput = getFirstByName('price-slider__min-value');
    var maxInput = getFirstByName('price-slider__max-value');

    if (!minInput || !maxInput) return;

    var minValue = filterObject.moneyFormat.from(minInput.value);
    var maxValue = filterObject.moneyFormat.from(maxInput.value);

    if (typeof Currency !== 'undefined' && Currency.convert) {
      minValue = parseFloat(Currency.convert(minValue, 'CAD', safeCurrency)).toFixed(2);
      maxValue = parseFloat(Currency.convert(maxValue, 'CAD', safeCurrency)).toFixed(2);
    }

    safeSetHTML('price-slider__slider-range-value1', minValue);
    safeSetHTML('price-slider__slider-range-value2', maxValue);

    updateAllFilters();
  });
}

      /*========= 
        WEIGHT FILTER / SLIDER
        ========= */

      filterObject.weightFormat = wNumb({
          decimals: 0,
          suffix: ' lbs'
      });

      filterObject.weightSlider = document.querySelector(selectors.weightSlider);
      if (window.noUiSlider == undefined) return;
      noUiSlider.create(filterObject.weightSlider, {
          start: [0, 10],
          connect: true,
          step: 1,
          range: {
              'min': 0,
              'max': 10
          },
          format: filterObject.weightFormat
      });

      filterObject.weightSlider.noUiSlider.on('change',function(value,handle){
        var filterName = 'weight';
        filterObject.lastFilterSelected = filterName;
        filterObject.filterCategoryOrder.push(filterName)
        filterObject.filtersActivated = true;

        if (filterObject.weightFormat.from(value[0]) == filterObject.defaultWeight[0] && filterObject.weightFormat.from(value[1]) == filterObject.defaultWeight[1]) {
            filterObject.weightFilterSelected = undefined;
        } else {
          filterObject.weightFilterSelected = [filterObject.weightFormat.from(value[0]),filterObject.weightFormat.from(value[1])];
        }
        
        reloadItemsWithFilters();
      });

      // Set visual min and max values and also update value hidden form inputs
      filterObject.weightSlider.noUiSlider.on('update', function(values, handle) {
        document.getElementById('weight-slider__slider-range-value1').innerHTML = values[0];
        document.getElementById('weight-slider__slider-range-value2').innerHTML = values[1];
        safeSetValue('weight-slider__min-value', filterObject.weightFormat.from(values[0]));
        safeSetValue('weight-slider__max-value', filterObject.weightFormat.from(values[1]));
      });


      /*========= 
        Breast CUP FILTER / SLIDER
        ========= */
      filterObject.cupFormat = wNumb({
          edit: function( value ){
            var numberToSize = {1: "A", 2: "B", 3: "C", 4: "D", 5: "E", 6: "F", 7: "G", 8: "H", 9: "I", 10:"J", 11: "K", 12: "L", 13: "M", 14: "N", 15: "O", 16: "P", 17: "Q", 18: "R", 19: "S", 20: "T"}
            var result = numberToSize[parseInt(value)]; //"duct tape"
            //console.log("FORMAT: " + value + "  " + result);
            return result;
          }
      });

      filterObject.cupSize = document.querySelector(selectors.cupSlider);
      if (window.noUiSlider == undefined) return;
      noUiSlider.create(filterObject.cupSize, {
          connect: true,
          step: 1,
          range: {
              'min': 1,
              'max': 9
          },
          start: [1, 9],
          format: filterObject.cupFormat
      });

      // Set visual min and max values and also update value hidden form inputs
      filterObject.cupSize.noUiSlider.on('update', function(values, handle) {
        document.getElementById('breast_cup__slider-range-value1').innerHTML = values[0];
        document.getElementById('breast_cup__slider-range-value2').innerHTML = values[1];
        safeSetValue('breast_cup__min-value', filterObject.cupFormat.from(values[0]));
        safeSetValue('breast_cup__max-value', filterObject.cupFormat.from(values[1]));
      });

      // Add Event

      filterObject.cupSize.noUiSlider.on('change',function(value,handle){
        filterObject.filtersActivated = true;
        // console.log(value)
        if (breastConvert(value[0]) == breastConvert(filterObject.defaultCup[0]) && breastConvert(value[1]) == breastConvert(filterObject.defaultCup[1])) {
            filterObject.cupSizeFilterSelected = undefined;
            // console.log("BREAST FORMAT BACK TO NORMAL, undefined")
        } else {
          filterObject.cupSizeFilterSelected = [value[0],value[1]];
        }
        filterObject.lastFilterSelected = 'breast-cup';
        reloadItemsWithFilters();
      });


      /*========= 
        HEIGHT FILTER / SLIDER
        ========= */

      filterObject.heightFormat = wNumb({
        decimals: 0,
        suffix: ' cm'
      });

      filterObject.heightSlider = document.querySelector(selectors.heightSlider);
      if (window.noUiSlider == undefined) return;
      noUiSlider.create(filterObject.heightSlider, {
          start: [0, 200],
          connect: true,
          step: 1,
          range: {
              'min': 0,
              'max': 200
          },
          format: filterObject.heightFormat
      });

      filterObject.heightSlider.noUiSlider.on('change',function(value,handle){
        var filterName = 'height';
        filterObject.lastFilterSelected = filterName;
        filterObject.filterCategoryOrder.push(filterName)
        filterObject.filtersActivated = true;

        if (filterObject.heightFormat.from(value[0]) == filterObject.defaultHeight[0] && filterObject.heightFormat.from(value[1]) == filterObject.defaultHeight[1]) {
            filterObject.heightFilterSelected = undefined;
        } else {
          filterObject.heightFilterSelected = [filterObject.heightFormat.from(value[0]),filterObject.heightFormat.from(value[1])];
        }
        
        reloadItemsWithFilters();
      });

      // Set visual min and max values and also update value hidden form inputs
      filterObject.heightSlider.noUiSlider.on('update', function(values, handle) {
        document.getElementById('height-slider__slider-range-value1').innerHTML = values[0];
        document.getElementById('height-slider__slider-range-value2').innerHTML = values[1];
        safeSetValue('height__min-value', filterObject.heightFormat.from(values[0]));
        safeSetValue('height__max-value', filterObject.heightFormat.from(values[1]));
      });

      /*========= 
        LOADMORE
        ========= */

      filterObject.loadMore = $(selectors.loadMore);
      
      filterObject.loadMore.find('a').click(function(){
        showProducts();
      })

      // RESET BUTTON

      /* commented out by Jason2 when we changed "Reset All" from Clickable Text to a Button
      $('.sidebar__reset').find("span").click(function(){
        resetAll();
        $('[data-option-filter]').each(function(index,value){
            this.checked=false;
            //console.log(this.id);
        });
        console.log("RESET")
      })*/
      
      //updated version of filter reset button handler by jason2 on dec 2, 2020
      $('.filterResetButton').click(function(){
        resetAll();
        $('[data-option-filter]').each(function(index,value){
            this.checked=false;
            //console.log(this.id);
        });
        console.log("RESET")
      })

      removeAllProducts();
      removeLoadMore();
      retrieveRemainingProducts(1,true,false);

    }

    initializeSettings();
	
    //added by jason2 to handle any filters that are present in the url (dec 8 2020)
    //this doesn't seem to break the page even if no filters are selected
    reloadItemsWithFilters()
  }

  /*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

var collectionSidebarFilter = {
    init: function(){
  
      $('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').hide();
      $('.toggle-all--true .toggle_list .filter-active-tag input:checked').parents('ul.toggle_list').prev().click();
  
      //Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(2) === 'types' || $.url(2) === 'vendors'){
        $('.sidebar__collection-filter').remove();
      }
  
      $('.sidebar-block:empty').prev().css('border-bottom', 'none');
  
    },
    clearAllFilters: function(){
      $('[data-option-filter] input').attr('checked', false);
      $('[data-option-filter] input').trigger('change');
    },
    clearSelectedFilter: function(optionFilter){
      optionFilter.find('[data-option-filter] input').attr('checked', false);
      optionFilter.find('[data-option-filter] input').trigger('change');
    }
  }
  
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })
  
  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });
  
  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
});

/*============================================================================
  Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function(){
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3'),
        path = url1 + url2;

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function (){
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
        console.log(currentTags)
      } else {
        currentTags += selectedOptions[i];
      }

    });
    Shopify.queryParams.sort_by = query;
    
    query = '?' + $.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
    console.log(path, currentTags, query);
  },
  updateView: function(filterURL) {
    console.log("FilterURL", filterURL);
    $.ajax({
       type: 'GET',
       url: filterURL,
       beforeSend: function() {
          $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
          Waypoint.destroyAll()
       },
       success: function(data) {
          $(".collection-matrix").removeClass('loading-in-progress');
          $(".collection-matrix").removeClass('filter-loading');
          var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
          $('.breadcrumb_text').html(filteredBreadcrumb);

          var products = $(data).find('.product-wrap')
          console.log(products)

          var filteredPagination = $(data).find('.paginate').html();
          $('.paginate').html(filteredPagination);

          var filteredSidebar = $(data).find('.sidebar').html();
          $('.sidebar').html(filteredSidebar);

          var filteredPageLinks = $(data).find('.paginate').html();
          $('.paginate').empty();
          $('.paginate').html(filteredPageLinks);

          var filteredData = $(data).find('.collection-matrix');
          $('.collection-matrix').remove();
          filteredData.insertBefore( $('.load-more__icon') );

          window.history && window.history.pushState && window.history.pushState("", "", filterURL);

          if ($('.sidebar__collection-filter').length){
            collectionSidebarFilter.init();
          }

          if (shopify_global.pagination_type == 'infinite_scroll'){
            enableInfiniteScroll();
          }

          if (shopify_global.show_multiple_currencies == 'true') {
            convertCurrencies();
          }

          if (shopify_global.enable_shopify_collection_badges == 'true'){
            SPR.$(document).ready(function() {
              return SPR.registerCallbacks(),
              SPR.initRatingHandler(),
              SPR.initDomEls(),
              SPR.loadProducts(),
              SPR.loadBadges()
            })
          }
       },
       error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

       },
       dataType: "html"
    });
  },
  processUrl: function(path, tags, query){

    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';

    urlString = path + tags + query;

    quickFilter.updateView(urlString);

  }
}

$('#sort-by').val($('#sort-by').data('default-sort'));

$('body')
  .on('change', '#tag_filter, #sort-by', function() {
    quickFilter.init();
});

$('body')
  .on('change', '#blog_filter', function() {
    var url = $(this).val();
    window.location = url;
});

$('input, select, textarea').on('focus blur', function(event) {
  $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
});
